const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiAuthorization.PUBLIC, ApiDataModel.PRODUCTION_PLAN_MEALS)

export const apiProductionPlanMeals = {
	fetchProductionPlanMeals: async (variantIDs: number[], date?: string): Promise<IProductionPlanMealModel[]> => {
		const { data } = await apiCommon<IProductionPlanMeal[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(undefined, { variant_ids: variantIDs, date }),
		})

		if (!data) return []

		return data.map(ProductionPlanMeal)
	},
}
